import React from 'react';
import { ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CurrencyNote } from './CurrencyNote';
import { alreadyGo } from '../data/content';
import { CtaButton } from './CtaButton';
import { LeafSprig } from './decor/LeafSprig';
const mechanism = ['Print.', 'Cut.', 'Share.', 'Plant the seed.'];
export function FinalClose() {
  return <section aria-labelledby="close-title" className="bg-paper" data-id="element-73" data-mp="i6sksoi5hs45">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-74" data-mp="1fszrc3y0luj5">
        <div className="grid gap-14 lg:grid-cols-[1fr_460px] lg:items-center lg:gap-16" data-id="element-75" data-mp="1atwuv7w3owms">
          <div data-id="element-76" data-mp="162wwrzb8w8ip">
            <h2 id="close-title" className="text-balance font-display text-[40px] leading-[1.04] text-navy sm:text-[54px]" data-id="element-77" data-mp="162eqsays6fxl">
              How Many Seeds Will You Plant This Week?
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-78" data-mp="1yjr4zhp1c73c">
              Another week can pass exactly like the last one. <strong className="text-navy" data-id="element-79" data-mp="1trg5gfy7inbb">Or this can be the week you start.</strong>
            </p>
            <ul className="mt-6 grid gap-2 text-lg text-ink-soft sm:grid-cols-2" data-id="element-80" data-mp="nqdk80v06d0s">
              {alreadyGo.map(a => <li key={a} data-id="element-81" data-mp="snm3k4rw0n3m">{a}</li>)}
            </ul>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-82" data-mp="e0apnw88gr0c">
              The opportunities are already around you. Now you can have 200+ Bible verses across 20+ different Gospel-sharing designs ready for
              those opportunities.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-ink-soft" data-id="element-83" data-mp="90g2o3rkwlkk">
              You don’t need to wait until you feel fearless. You don’t need to wait until you know everything.{' '}
              <strong className="text-navy" data-id="element-84" data-mp="3r8dw3r3oj2jo">You just need to be willing to take the first step.</strong>
            </p>
            <ol className="mt-8 flex flex-wrap gap-x-4 gap-y-1" data-id="element-85" data-mp="1pexu5y25619e">
              {mechanism.map((m, i) => <li key={m} className={`font-display text-3xl sm:text-4xl ${i === mechanism.length - 1 ? 'italic text-leaf-deep' : 'text-navy'}`} data-id="element-86" data-mp="1ueap76362en2" data-mpi={i}>
                  {m}
                </li>)}
            </ol>
          </div>

          <div className="relative rounded-3xl bg-cream p-8 text-center shadow-sheet ring-2 ring-coral/25 sm:p-10" data-id="element-87" data-mp="1nvxul5v12en6">
            <LeafSprig className="absolute -right-3 -top-8 h-20 w-10 rotate-12 text-leaf/60" data-id="element-88" data-mp="1j0iiaico4qsv" />
            <p className="font-display text-2xl leading-tight text-navy sm:text-[28px]" data-id="element-89" data-mp="1e1fmloikvwxk">Get the Gospel Sharing Mega Bundle</p>
            <p className="mt-2 font-display text-[88px] leading-none text-coral" aria-label="$24.90" data-id="element-90" data-mp="26o0b8h7o5uxf">
              $24<span className="align-top text-[44px] leading-none" data-id="element-91" data-mp="21x0ilo5l1z0q">.90</span>
            </p>
            <p className="mt-4 text-sm font-semibold leading-relaxed text-ink-soft" data-id="element-92" data-mp="1wy71llr37pvt">
              200+ Bible Verses · 20+ Printable Designs · 5 Bonuses · Instant Digital Access · 7-Day Guarantee
            </p>
            <CurrencyNote className="mt-6 border-t border-cream-line pt-5" data-id="element-93" data-mp="2pmcnibtvnkx8" />
            <CtaButton checkout block className="mt-4" data-id="element-94" data-mp="2pl1n8lzn4vav">
              Get Instant Access Now
            </CtaButton>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-semibold text-ink-soft" data-id="element-95" data-mp="31wu4qwo2ewxc">
              <span className="inline-flex items-center gap-1.5" data-id="element-96" data-mp="36v5k1mx4pzmy">
                <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-97" data-mp="3bv0a5o92yl6y" />
                Instant Digital Access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-98" data-mp="3gtl9llgid0uc">
                <ShieldCheckIcon className="h-4 w-4 text-leaf-deep" aria-hidden="true" data-id="element-99" data-mp="3kvg70evbiu2u" />
                7-Day Guarantee
              </span>
            </div>
          </div>
        </div>
        <p className="mx-auto mt-16 max-w-2xl text-center font-display text-2xl italic leading-snug text-navy sm:text-3xl" data-id="element-100" data-mp="3ulhylgmvqumi">
          Because someone you cross paths with this week may need the message you’re carrying.
        </p>
      </div>
    </section>;
}